<script lang="ts">
     const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

</script>
  
  <svelte:head>
    <title>LogMyPoop App Privacy Policy</title>
    <link rel="icon" type="image/png" href="images/favicon.png" />
    <meta name="viewport" content="width=device-width, initial-scale=1,user-scalable=0">
    <meta name="viewport" content="width=device-width, initial-scale=1,user-scalable=0">
    <meta name="title" content="LogMyPoop | Log My Poop - Digestive Heakth Tracking App Privacy Policy">
    <meta name="description" content="Free Bowel, Gut and Digestive Health Tracking iOS and Android App. This app helps for constipation relief,Irritable bowel syndrome (IBS) and provides Digestive support.">
    <meta name="keywords" content="Bowel Health, Digestive wellness, Gut health, Intestinal health, 
    Poop Log, Poop Diary, Log Poop, Digestive support, Probiotics for digestive health,Digestive enzymes,Gastrointestinal health
    Constipation relief,Fiber for digestive health,Irritable bowel syndrome (IBS),Log My Poop, LogMyPoop, Squaredojo, Free Health App, Free App, Bristol Chart, Bristol Stool, Constipation">
    <meta name="robots" content="index, follow">
    <meta lang="english" content="text/html; charset=utf-8">
    <meta name="language" content="English">
    <meta name="revisit-after" content="30 days">
    <meta name="author" content="Squaredojo">
  </svelte:head>
  <!-- nav -->
  <nav class="flex bg-purple-50">
    <a href="/#/logmypoop" class="p-2">
      <img
        src="../images/logmypoop/favicon.png"
        width="42"
        alt="LogMyPoop App logo"
      />
    </a>
    <h5 class="font-black text-purple-900 text-2xl  pt-1 w-1/2">
        LogMyPoop App
    </h5>
    <!-- Menu -->
  </nav>

  <section id="what_can_it_do" class="bg-palepink-400 pt-20">
    <div class="text-center">
      <span class="text-purple-700 font-bold mb-10 text-3xl md:text-4xl">Our Privacy Policy</span>
      <br/>
      Last Updated 06 Jan 2023
    </div>
  </section>
  <section id="what_can_it_do" class="bg-palepink-400 pt-20">
    <div class="text-center">
      <span class="text-purple-700 font-bold mb-10 text-3xl md:text-2xl">Why we collect information</span>
    <br/>
      <span class="font-bold mb-10 text-md lg:text-3xl md:text-lg">We may collect or hold information about your device only while you are using the
        LogMypoop app.  <br/>
        We collect this anonymous information for the sole purpose of improving our app for better use.</span>
    </div>
  </section>
  <section id="what_can_it_do" class="bg-palepink-400 pt-20">
    <div class="text-center">
      <span class="text-purple-700 font-bold mb-10 text-3xl md:text-2xl">What information we collect information</span>
    <br/>
      <span class="font-bold mb-10 text-md lg:text-3xl md:text-lg">We may collect including name of operating system and device information like model and make and screen dimensions, your interaction with our app in certain events. 
        <br/> Events include - A new profile is created, a report has beeen generated, export or import data happened and when there is crash we might log technical error messages and information about our software running on your device. We do not identify or tag you and not even identify your particular device.
        <br/>We do not screen record or voice record.</span>
    </div>
  </section>
  <section id="what_can_it_do" class="bg-palepink-400 pt-20">
    <div class="text-center">
      <span class="text-purple-700 font-bold mb-10 text-3xl md:text-2xl">How we use this information</span>
    <br/>
      <span class="font-bold mb-10 text-md lg:text-3xl md:text-lg"> We will only use the information to bring improvements in this app and assist us in fixing bugs. For example We would like to know what interaction were you doing when the app crashed. 
        We do not sell your information as there is no personal information about you collected anyway. This app has no adverts and makes marketing attempts.</span>
    </div>
  </section>
  <section id="what_can_it_do" class="bg-palepink-400 pt-20">
    <div class="text-center">
      <span class="text-purple-700 font-bold mb-10 text-3xl md:text-2xl">Any Questions</span>
    <br/>
      <span class="font-bold mb-10 text-md lg:text-3xl md:text-lg">logmypoop@squaredojo.com</span>
    </div>
  </section>
  <section id="what_can_it_do" class="bg-palepink-400 pt-20">
   
  </section>
  <footer class="bg-purple-900  -mb-12">
    <div class="container flex flex-row  mx-auto pt-10 justify-around">
      <div class="-mt-20 md:-mt-32">
        <img
          src="../images/logmypoop/success.png"
          alt="log my poop coming soon"
        />
      </div>
      <div class="flex flex-col">
        <h5 class="text-gray-50">FOLLOW</h5>
        <a
          href="https://twitter.com/squaredojo"
          target="_blank"
          class="no-underline text-gray-400 text-lg py-4 hover:underline"
          >Twitter</a
        >
        <a
          href="https://www.instagram.com/squaredojo/"
          target="_blank"
          class="no-underline text-gray-400 text-lg  py-4 hover:underline"
          >Instagram</a
        >
      </div>
      <div class="flex flex-col invisible md:visible">
        <h5 class="text-gray-50">HELP</h5>
        <a
          href="#"
          class="no-underline text-gray-400 text-lg  py-4 hover:underline">FAQ</a
        >
        <a
          href="#"
          class="no-underline text-gray-400 text-lg  py-4 hover:underline"
          >Contact</a
        >
      </div>
      <div class="flex flex-col pr-2 -ml-10">
        <h5 class="text-gray-50">ABOUT</h5>
        <a
          href="#"
          class="no-underline text-gray-400 text-lg  py-4 hover:underline"
          >Squaredojo</a
        >
        <a
          href="#/logmypoop"
          class="no-underline text-gray-400 text-lg  py-4 hover:underline"
          >LogMyPoop App</a
        >
      </div>
      <div>
        <button
          on:click={scrollToTop}
          type="button"
          data-mdb-ripple="true"
          data-mdb-ripple-color="light"
          class="inline-block p-3 bg-japanese-200 text-white font-medium text-xs rounded-full shadow-md hover:bg-japanese-600 hover:shadow-lg focus:bg-japanese-900 focus:shadow-lg 
        focus:outline-none focus:ring-0 active:bg-japanese-900 active:shadow-lg transition duration-150 ease-in-out  bottom-5 right-5 fixed z-10"
          id="btn-back-to-top"
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            class="w-4 h-4"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="container mx-auto text-center text-gray-400 p-5 opacity-50">
      <!-- svelte-ignore a11y-invalid-attribute -->
      2022 | Made with ❤ by <a href="#">SquareDojo</a>
    </div>
  </footer>
  